import ContentParameterSectionList from 'features/content-parameter-section-list/ContentParameterSectionList';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import SiteConfigPage from 'pages/site-config/shared/SiteConfigPage';

function SiteConfigContentPresentationList() {
  useRequireRoles(ROLE_TYPE.ADMIN, ROLE_TYPE.SUPER);

  return (
    <SiteConfigPage title="Section Pages">
      <ContentParameterSectionList />
    </SiteConfigPage>
  );
}

export default SiteConfigContentPresentationList;
